const ABBREVIATION_WORDS = [{ text: 'sth', fullWord: 'something' }];

export const expandAbbreviationToFullWord = (abbreviationText: string) => {
  if (!abbreviationText) {
    return abbreviationText;
  }
  const foundAbbreviation = ABBREVIATION_WORDS.find(
    (eachAbbreviation) => eachAbbreviation?.text === abbreviationText?.toLowerCase()
  );

  return foundAbbreviation?.fullWord || abbreviationText;
};

export const isAbbreviation = (text) => {
  if (!text) {
    return false;
  }
  return ABBREVIATION_WORDS.some(
    (eachAbbreviation) => eachAbbreviation.text === text.toLowerCase()
  );
};
